import { isServer } from "./index";

let prev = Date.now();

/**
 * requestAnimationFrame 的补丁
 * @param { Function } 要执行的函数
 * @return private
 */
function fallback(fn) {
  const curr = Date.now();
  const ms = Math.max(0, 16 - (curr - prev));
  const id = setTimeout(fn, ms);
  prev = curr + ms;
  return id;
}

const root = isServer ? global : window;
const iRaf =
  root.requestAnimationFrame || root.webkitRequestAnimationFrame || fallback;

export function raf(fn) {
  return iRaf.call(root, fn);
}

/*
 * 格式化日期
 * @param {String} 日期
 * @param {String} 格式
 * @return {String}
 */
export function formatter(date, fomtt) {
  let YYYY = date.getFullYear();
  let MM = date.getMonth() + 1;
  let DD = date.getDate();

  if (MM < 10) {
    MM = "0" + MM;
  }

  if (DD < 10) {
    DD = "0" + DD;
  }

  switch (fomtt) {
    case "YYYY-MM-DD":
      return YYYY + "-" + MM + "-" + DD;
    case "YYYY-MM":
      return YYYY + "-" + MM;
    case "MM月DD日":
      return MM + "月" + DD + "日";
    case "MM-DD":
      return MM + "-" + DD;
    default:
      return YYYY + "-" + MM + "-" + DD;
  }
}
